import { render, staticRenderFns } from "./companySelector.vue?vue&type=template&id=0c0edf8b&scoped=true&"
import script from "./companySelector.vue?vue&type=script&lang=js&"
export * from "./companySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0edf8b",
  null
  
)

export default component.exports